import { Box } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RoundedButton from '@src/components/UI/RoundedButton';
import { GetContactsResponseData } from '@src/reducers/contactsApi';
import type { RootState } from '@src/store/reduxstore';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import StartChatWithContactDialog from '../AdminHome/Contact/StartChatWithContactDialog';
import ContactList from './ContactList';
import StartContactCallDialog from './StartContactCall/StartContactCallDialog';

const StartContactConversation: React.FC = () => {
  const [isShowContactList, setIsShowContactList] = useState(false);

  const [selectedContactChat, setSelectedContactChat] =
    useState<GetContactsResponseData | null>(null);

  const [selectedContactCall, setSelectedContactCall] =
    useState<GetContactsResponseData | null>(null);

  const accountCheckedValue = useSelector((state: RootState) => {
    const { accountToStartChatChecked } = state.adminHome.contact
      .contacts as unknown as { accountToStartChatChecked: boolean };
    return accountToStartChatChecked;
  });

  return (
    <Box>
      <RoundedButton
        disableElevation
        color="primary"
        variant="outlined"
        className="rounded"
        onClick={() => setIsShowContactList(true)}
        data-testid="contact-create-button"
        style={{ height: 38, width: 38 }}
      >
        <AddIcon />
      </RoundedButton>

      {isShowContactList && (
        <ContactList
          open={isShowContactList}
          setOpen={setIsShowContactList}
          setOpenChatWithContact={setSelectedContactChat}
          setOpenChatWithCall={setSelectedContactCall}
        />
      )}

      {selectedContactChat?.id && (
        <StartChatWithContactDialog
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          accountChecked={accountCheckedValue}
          openWithContact={selectedContactChat}
          onClose={setSelectedContactChat}
        />
      )}

      {selectedContactCall?.id && (
        <StartContactCallDialog
          contact={selectedContactCall}
          accountChecked={accountCheckedValue}
          onClose={() => setSelectedContactCall(null)}
        />
      )}
    </Box>
  );
};

export default StartContactConversation;
